import z from 'zod';

import { socialApiClient } from '@/shared/api-client/social-api-client';

export const executeDiscoverySearchRequestSchema = z.object({
  message_id: z.string(),
});

export const discoverySearchResponseSchema = z.object({
  search_id: z.string(),
  complete: z.boolean(),
  progress_percentage: z.number().int().min(0).max(100),
});

export type DiscoverySearchResponse = z.infer<typeof discoverySearchResponseSchema>;
export type ExecuteDiscoverySearchRequest = z.infer<typeof executeDiscoverySearchRequestSchema>;

export async function executeDiscoverySearch(
  discoverySessionId: string,
  request: ExecuteDiscoverySearchRequest,
  signal?: AbortSignal,
): Promise<DiscoverySearchResponse> {
  const parsedRequest = executeDiscoverySearchRequestSchema.parse(request);
  const response = await socialApiClient.post(`discovery-sessions/${discoverySessionId}/search`, {
    json: parsedRequest,
    signal,
  });

  return discoverySearchResponseSchema.parse(await response.json());
}
